module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/change_desktop-b9fbc59bb57d6259993b4c706ebae233.png";